import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SwitchToggle from "../../../components/SwitchToggle";
import { useGetBrandDetailsQuery } from "../../../service/features/api";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";

const BrandDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const brandId = location.state?.id;

  const { data: brandData, isLoading } = useGetBrandDetailsQuery(brandId, {
    skip: !brandId,
  });

  useEffect(() => {
    if (!brandId) {
      toast.error("No brand selected");
      navigate("/manage-brands");
    }
  }, [brandId, navigate]);

  const brand = brandData?.data;

  if (isLoading || !brand) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {/* Page Title */}
      <CommonBreadcrumb
        title="Brand Detail"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Manage Brands", onClick: () => navigate("/manage-brands") },
          { label: "Brand Detail" },
        ]}
      />

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_33">
            <h6>Brand Logo</h6>
            <figure>
              <img
                src={brand.logo || "/static/images/placeholder.png"}
                alt={brand.name}
                onError={(e: any) => { e.target.src = "/static/images/placeholder.png" }}
              />
            </figure>
          </div>
          <div className="w_33">
            <h6>Brand Name</h6>
            <p>{brand.name}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{moment(brand.createdAt).format("DD MMM YYYY")}</p>
          </div>

          <div className="w_33">
            <h6>Popular</h6>
            <p>{brand.isPopular ? "Yes" : "No"}</p>
          </div>
          <div className="w_33">
            <h6>Status</h6>
            <span className={`status_btn dark ${brand.isActive ? "c_success" : "c_danger"}`}>
              {brand.isActive ? "Active" : "Inactive"}
            </span>
          </div>

          <div className="w_100">
            <h6>Description</h6>
            <p dangerouslySetInnerHTML={{ __html: brand.description || "No description provided" }}></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandDetail;
